export enum Align {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
